import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';

import AssignPlaces from '../TableBookingSettingsListings/AssignPlaces';

const Wrapper = styled.nav`
  padding: 1rem;
  border-bottom: 1px solid #f5f8fa;
  padding-bottom: 1rem;
`;

const BoxWrapper = styled.nav`
  &&& {
    background: #f6f6f6;
  }
`;

const Search = ({ placeName, handleChange }) => (
  <Wrapper>
    <BoxWrapper className="box">
      <div className="columns">
        <div className="column is-4">
          <AssignPlaces
            onChange={id => {
              handleChange({ placeFilter: id });
            }}
            placeId={placeName}
            key={placeName}
          />
        </div>
      </div>
    </BoxWrapper>
  </Wrapper>
);

export default withRouter(Search);
